export default __webpack_public_path__ + "static/media/wheel-indon-b.d1bf4105.webp";